module.exports = __webpack_public_path__ + "img/hair_back_female_frizzy_short_mask.8d11eba0.png";